module.exports = __webpack_public_path__ + "static/media/liveTrends.86e9b53f.svg";